import request from '@/utils/request'

let CourseApi = {
  /*章节列表*/
  chapterList(data, errorback) {
    return request._post('/shop/plus.course.chapter/index', data, errorback);
  },
  /*章节添加*/
  chapterAdd(data, errorback) {
    return request._post('/shop/plus.course.chapter/add', data, errorback);
  },
  /*章节编辑数据*/
  chapterDetail(data, errorback) {
    return request._get('/shop/plus.course.chapter/edit', data, errorback);
  },
  /*章节编辑*/
  chapterEdit(data, errorback) {
    return request._post('/shop/plus.course.chapter/edit', data, errorback);
  },
  /*章节删除*/
  chapterDel(data, errorback) {
    return request._post('/shop/plus.course.chapter/delete', data, errorback);
  },
  /*课程列表*/
  courseList(data, errorback) {
    return request._post('/shop/plus.course.course/index', data, errorback);
  },
  /*课程添加*/
  courseAdd(data, errorback) {
    return request._post('/shop/plus.course.course/add', data, errorback);
  },
  /*课程编辑数据*/
  courseDetail(data, errorback) {
    return request._get('/shop/plus.course.course/edit', data, errorback);
  },
  /*课程编辑*/
  courseEdit(data, errorback) {
    return request._post('/shop/plus.course.course/edit', data, errorback);
  },
  /*课程删除*/
  courseDel(data, errorback) {
    return request._post('/shop/plus.course.course/delete', data, errorback);
  },
  /*课程购买用户列表*/
  courseRecordList(data, errorback) {
    return request._post('/shop/plus.course.record/index', data, errorback);
  },
  /*保存设置*/
  saveSetting(data, errorback) {
    return request._post('/shop/plus.course.setting/index', data, errorback);
  },
  /*获取设置*/
  getSetting(data, errorback) {
    return request._get('/shop/plus.course.setting/index', data, errorback);
  },
}

export default CourseApi;



// WEBPACK FOOTER //
// ./src/api/course.js